import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_+lastUpdate_active",
  "use": "sort_+lastUpdate_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_+lastUpdate_active\"><path fill-rule=\"evenodd\" d=\"m10 9.293 2.39 2.389a.5.5 0 1 1-.708.707L9.146 9.854A.498.498 0 0 1 9 9.5v-4a.5.5 0 0 1 1 0v3.793ZM9.5 17a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol